import CardPlacingOrder from '@/entities/cart-page/CardPlacingOrder'
import {
    changePaymentMethodValue,
    updatePaymentMethod,
    changeCurrentStep
} from '@/shared/store/slice/cartSlice'
import classNames from 'classnames'
import { useEffect } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

export const PaymentMethods = ({userInfo, cert}) => {
    const dispatch = useDispatch()

    const {
        customer,
        areaType,
        currentStep: step,
        paymentMethods: data,
        paymentMethodValue,
    } = useSelector((state) => state.cartActions)

    useEffect(() => {
        dispatch(changeCurrentStep({currentStep: 3}))
    }, [dispatch])

    // Сортировка методов
    const methods = data ? Object.values(data) : []
    let sortedMethods = methods.sort((a, b) =>
        a.sort_order > b.sort_order ? 1 : -1
    )

    const handleChangeStep = () => {
        dispatch(updatePaymentMethod({ payment_method: paymentMethodValue, userInfo }))
    }

    const handleChange = (type) => {
        dispatch(changePaymentMethodValue(type))
    }

    if (!data) {
        return <div>Ошибка загрузки способов оплаты</div>
    }

    if(cert) {
        sortedMethods = sortedMethods.filter((item)=>item?.code == 'modulbank');
    }
    
    return (
        <CardPlacingOrder
            stepTitle={'Шаг 3: Способ оплаты'}
            changeStep={handleChangeStep}
            className={classNames(step < 3 ? 'disabled-step' : '')}
            textButton={'Следующий шаг'}
            currentStep={step === 3}
            isValid={paymentMethodValue}
        >
            <h3>Выберите способ оплаты заказа:</h3>
            {sortedMethods.map((item) => {
                if (areaType == 'another') {
                    if (item.code == 'cheque') return
                }
                return (
                    <InputGroup key={item.code}>
                    <Form.Check
                        checked={paymentMethodValue === item.code}
                        id={item.code}
                        type={'radio'}
                        name="payment_method"
                        onChange={() => {
                            // console.log(item.code)
                            handleChange(item.code)
                        }}
                        // onChange={() => handleChange('cheque')}
                    />
                    <label htmlFor={item.code}>
                        <span>{item.title}</span>
                    </label>
                </InputGroup>
                )
            })}
        </CardPlacingOrder>
    )
}
